import axios from 'axios'

export default function (route, body) {
  return axios.post(process.env.REACT_APP_API_URL + '/' + route, body)
    .then(response => {
     return response.data
    })
}



// WEBPACK FOOTER //
// ./src/api.js